import URL from "../api_url";

export const AUTH_API = `${URL}/login`;

export const AUTH_WHOAMI_API = `${URL}/who-am-i`;

export const AUTH_RECOVERY_API = `${URL}/forgot-password`;

export const AUTH_VALIDATE_API = `${URL}/change-password`;
